(() => {
  const config = {
    origin: { city: 'Greater Noida', pincode: '201308' },
    production: { minDays: 2, maxDays: 2 },
    // Merchant-approved transit estimates, not courier serviceability rules.
    // Exact overrides take precedence over conservative postal-area groups.
    pincodeZones: { '201308': 'local', '201319': 'local', '201010': 'local', '201301': 'local', '201303': 'local', '201304': 'local', '201306': 'local', '201309': 'local', '201310': 'local', '682555': 'remote' },
    zonePrefixes: [
      { zone: 'local', prefixes: ['110', '121', '122'] },
      { zone: 'metro', prefixes: ['400', '411', '560', '600', '700', '500', '380'] },
      { zone: 'remote', prefixes: ['744', '790', '791', '792', '793', '794', '795', '796', '797', '798', '194'] },
    ],
    zones: { local: [1, 2], metro: [2, 4], rest: [3, 6], remote: [5, 8] },
    excludedWeekdays: [0],
  };
  const key = 'saam_delivery_pincode';
  let memoryPin = '';
  const valid = pin => /^[1-9][0-9]{5}$/.test(pin);
  function getTransitEstimate(pin) {
    const normalized = String(pin).trim();
    const zone = valid(normalized)
      ? config.pincodeZones[normalized] || config.zonePrefixes.find(group => group.prefixes.some(prefix => normalized.startsWith(prefix)))?.zone || 'rest'
      : 'rest';
    const [minDays, maxDays] = config.zones[zone];
    return { minDays, maxDays, zone };
  }
  function indiaToday(now = new Date()) {
    const parts = new Intl.DateTimeFormat('en-CA', { timeZone: 'Asia/Kolkata', year: 'numeric', month: '2-digit', day: '2-digit' }).formatToParts(now);
    const part = type => Number(parts.find(p => p.type === type).value);
    return new Date(Date.UTC(part('year'), part('month') - 1, part('day')));
  }
  function addWorkingDays(date, days) {
    if (!Number.isInteger(days) || days < 0 || days > 365) throw new Error('Invalid lead time');
    const result = new Date(date);
    while (days > 0) {
      result.setUTCDate(result.getUTCDate() + 1);
      if (!config.excludedWeekdays.includes(result.getUTCDay())) days--;
    }
    return result;
  }
  function estimate(pin, now) {
    const transit = getTransitEstimate(pin);
    const today = indiaToday(now);
    const start = addWorkingDays(today, config.production.minDays + transit.minDays);
    const end = addWorkingDays(today, config.production.maxDays + transit.maxDays);
    const fmt = new Intl.DateTimeFormat('en-GB', { day: 'numeric', month: 'short', timeZone: 'UTC' });
    return `${fmt.format(start)}\u2013${fmt.format(end)}`;
  }
  function saved() { try { return localStorage.getItem(key) || memoryPin; } catch { return memoryPin; } }
  // Public pure helpers allow deterministic date/config testing, without requests.
  window.SaamDelivery = { config, getTransitEstimate, addWorkingDays, indiaToday, estimate };
  if (customElements.get('saam-delivery-estimate')) return;
  customElements.define('saam-delivery-estimate', class extends HTMLElement {
    connectedCallback() {
      this.abort = new AbortController();
      const opts = { signal: this.abort.signal };
      this.input = this.querySelector('[data-delivery-pin]');
      this.message = this.querySelector('[data-delivery-message]');
      this.querySelector('[data-delivery-check]')?.addEventListener('click', () => this.check(), opts);
      this.input?.addEventListener('keydown', e => { if (e.key === 'Enter') { e.preventDefault(); this.check(); } }, opts);
      this.querySelector('[data-delivery-change]')?.addEventListener('click', () => { this.edit(); this.input.focus(); }, opts);
      window.addEventListener('saam:delivery-change', () => this.restore(), opts);
      window.addEventListener('storage', e => { if (e.key === key) this.restore(); }, opts);
      this.restore();
    }
    disconnectedCallback() { this.abort?.abort(); }
    edit() { this.querySelector('[data-delivery-editor]').hidden = false; this.querySelector('[data-delivery-result]').hidden = true; }
    restore() {
      const pin = saved();
      if (this.hasAttribute('data-compact')) {
        const summary = this.querySelector('[data-delivery-summary]');
        try { summary.textContent = valid(pin) ? `Estimated delivery: ${estimate(pin)}` : 'Free Shipping in India'; }
        catch { summary.textContent = 'Free Shipping in India'; }
        return;
      }
      this.input.value = pin; valid(pin) ? this.show(pin) : this.edit();
    }
    check() {
      const pin = this.input.value.trim();
      if (!valid(pin)) { this.input.setAttribute('aria-invalid', 'true'); this.message.textContent = 'Enter a valid 6-digit PIN code.'; return; }
      this.input.removeAttribute('aria-invalid');
      memoryPin = pin;
      try { localStorage.setItem(key, pin); } catch { /* Private mode: retain for this page. */ }
      window.dispatchEvent(new Event('saam:delivery-change'));
    }
    show(pin) {
      try {
        this.querySelector('[data-delivery-dates]').textContent = `Estimated delivery: ${estimate(pin)}`;
        this.querySelector('[data-delivery-destination]').textContent = pin;
        this.querySelector('[data-delivery-editor]').hidden = true;
        this.querySelector('[data-delivery-result]').hidden = false;
        this.message.textContent = '';
      } catch { this.edit(); this.message.textContent = 'Delivery estimate unavailable right now.'; }
    }
  });
})();
